import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBackendURL } from '../utils';
import ProgressTabs from '../components/ProgressTabs';
import SweatTextTitle from '../steps/SweatTextTitle';
import RemindersInfo from './RemindersInfo';
import { useAuth } from '../auth';
import '../BasicReminder.css';

const StepTrainerTestMessage = () => {
  const { user, fetchUserInfo } = useAuth();
  const [sendingTestMsg, setSendingTestMsg] = useState(false);
  const [testMsgSent, setTestMsgSent] = useState(false);
  const [testMsgStatus, setTestMsgStatus] = useState('');
  // const [phone, setPhone] = useState(user?.phone || '');
  // const [consent, setConsent] = useState(false);
  const navigate = useNavigate();

  // Fetch consent and phone from user settings if needed
  // (Assume user object is up-to-date for simplicity)


  
    // Call fetchUserInfo when component mounts to ensure we have the latest user data
    useEffect(() => {
      fetchUserInfo();
    }, []);
  
  

  const handleSendTestMessage = async () => {
    setTestMsgStatus('');
    setSendingTestMsg(true);
    try {
      // /api/send-trainer-intro-text
      const res = await fetch(`${getBackendURL()}/api/send-trainer-intro-text`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`
        },
        body: JSON.stringify({
            current_user: user,
             trainer_user_id: user.user_id || user.id })
      });
      if (!res.ok) throw new Error('Failed to send test message');
      setTestMsgStatus('Test message sent!');
      setTestMsgSent(true);
    } catch (err) {
      setTestMsgStatus('Error: ' + err.message);
    } finally {
      setSendingTestMsg(false);
    }
  };

  // If no user redirect to homepage.
  if (!user) {
    return (
      <div className="reminder-container fogged-card">
        Sorry, you must be logged in to access this page.
      </div>
    );
  } 
  return (
    <div className="reminder-container fogged-card">
      <SweatTextTitle />
      <RemindersInfo />
      <ProgressTabs currentStep={3} />
      <h2 className="step-title">Step 4: Send Yourself a Test Message</h2>
      <p>Let's send you a message first before we set up your clients.</p>
      <div style={{ margin: '1rem 0' }}>

        {/* USER: {JSON.stringify(user)} <br />
        sendingTestMsg: {sendingTestMsg ? 'true' : 'false'} <br />
        testMsgSent: {testMsgSent ? 'true' : 'false'} <br />
        testMsgStatus: {testMsgStatus} <br />
        Phone: {user?.phone || '(no phone set)'} <br />
        Consent to SMS: {user?.settings?.sms_opt_in ? 'true' : 'false'} <br /> */}
        <button
          className="ptc-button"
          style={{ padding: '0.5rem 1rem', 
            fontSize: '1rem', 
            backgroundColor: sendingTestMsg || testMsgSent || !user.phone || !user.settings.sms_opt_in ? '#ccc' : '#007bff',
            cursor: sendingTestMsg || testMsgSent || !user.phone || !user.settings.sms_opt_in ? 'not-allowed' : 'pointer',
            position: 'relative', 
            minWidth: '180px' }}
          disabled={sendingTestMsg || testMsgSent || !user.phone || !user.settings.sms_opt_in}
          onClick={handleSendTestMessage}
        >
          {sendingTestMsg ? (
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span className="spinner" style={{
                width: '1rem',
                height: '1rem',
                border: '2px solid #ccc',
                borderTop: '2px solid #000',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginRight: '0.5rem',
              }}></span>
              Sending...
            </span>
          ) : (
            'Send test message'
          )}
        </button>
        {testMsgStatus && (
          <span style={{ color: testMsgStatus.startsWith('Error') ? 'red' : 'green', marginLeft: '1rem', fontSize: '0.95rem' }}>
            {testMsgStatus}
          </span>
        )}
      </div>

    <p>
        Once you receive the test message, you can proceed to the next step.
    </p>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
        <button className="ptc-secondary-button" onClick={() => navigate('/tools/reminders/step-consent')} style={{ padding: '1rem 2rem', fontSize: '1rem' }}>
          Previous Step
        </button>
        <button
          className="ptc-button"
          onClick={() => navigate('/tools/reminders/stepclientname')}
          style={{ padding: '1rem 2rem', 
            background: testMsgSent ? '#6610f2' : '#ccc', 
            color: testMsgSent ? 'white' : '#222', 
            border: 'none', 
            cursor: testMsgSent ? 'pointer' : 'not-allowed',
            fontSize: '1rem' }}
        >
          Next Step
        </button>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default StepTrainerTestMessage;
